export type ClientStatus = "Active" | "Trial" | "Suspended"

export type Industry =
  | "Technology"
  | "Manufacturing"
  | "Retail"
  | "Healthcare"
  | "Finance"
  | "Education"
  | "Logistics"
  | "Other"

export type ShareChoice = "same" | "different"

export type CompanyDetails = {
  companyName: string
  plan: "Starter" | "Growth" | "Enterprise"
  contactPersonName: string
  contactPersonEmail: string
  contactPersonNo: string
  address: string
  billingAddress: string
  billingSameAsAddress: boolean
  industry: Industry
  gstNo: string
  pan: string
  tan: string
  logoFile: File | null
  domain: string
  slug: string
  website: string
  bankAccountNo: string
  ifscCode: string
  status: ClientStatus
}

export type AdditionalCompany = CompanyDetails & {
  localId: string
  domainMode: ShareChoice
  slugMode: ShareChoice
  logoMode: ShareChoice
}

export const INDUSTRY_OPTIONS: Industry[] = [
  "Technology",
  "Manufacturing",
  "Retail",
  "Healthcare",
  "Finance",
  "Education",
  "Logistics",
  "Other",
]

export function createEmptyCompanyDetails(): CompanyDetails {
  return {
    companyName: "",
    plan: "Starter",
    contactPersonName: "",
    contactPersonEmail: "",
    contactPersonNo: "",
    address: "",
    billingAddress: "",
    billingSameAsAddress: false,
    industry: "Technology",
    gstNo: "",
    pan: "",
    tan: "",
    logoFile: null,
    domain: "",
    slug: "",
    website: "",
    bankAccountNo: "",
    ifscCode: "",
    status: "Trial",
  }
}

export function createEmptyAdditionalCompany(): AdditionalCompany {
  return {
    ...createEmptyCompanyDetails(),
    localId: `company-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    domainMode: "same",
    slugMode: "same",
    logoMode: "same",
  }
}
